import type { Requests } from "../common/request.common";
import type { MarketingDisbursementResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const marketingDisbursement = {
    record(data: typeof Requests.MarketingDisbursement.Record.Input) {
        return post<typeof data, MarketingDisbursementResponseTypes.Record>(
            `/marketing-disbursement/record`,
            data,
        );
    },
    claimRecord(data: typeof Requests.MarketingDisbursement.ClaimRecord.Input) {
        return post<typeof data, MarketingDisbursementResponseTypes.ClaimRecord>(
            `/marketing-disbursement/claim-record`,
            data,
        );
    },
    balance() {
        return get<MarketingDisbursementResponseTypes.Balance>(`/marketing-disbursement/balance`);
    },
    create(data: typeof Requests.MarketingDisbursement.Create.Input) {
        return post<typeof data>(`/marketing-disbursement/create`, data);
    },
    accept(id: string) {
        return postEmpty(`/marketing-disbursement/accept/${id}`);
    },
    reject(id: string) {
        return postEmpty(`/marketing-disbursement/reject/${id}`);
    },
    obtain(id: string) {
        return get<MarketingDisbursementResponseTypes.Obtain>(
            `/marketing-disbursement/obtain/${id}`,
        );
    },
    calculateFee(data: typeof Requests.MarketingDisbursement.CalculateFee.Input) {
        return post<typeof data, MarketingDisbursementResponseTypes.CalculateFee>(
            `/marketing-disbursement/calculate-fee`,
            data,
        );
    },
};
